import {
  ColorPickerProps,
  ColorPicker as OriginalColorPicker,
} from 'primereact/colorpicker';
import { classNames } from 'primereact/utils';
import InputEnhancements, { FormInputEnhancements } from './input-enhancements';
import WithController from '../with-controller';

const ColorPicker = WithController<PropTypes, string>(
  ({
    className,
    field,
    fieldState,
    formState: _formState,
    addonRight,
    addonLeft,
    label,
    withErrorMessage,
    containerClassName,
    triggerDependencies,
    ...props
  }) => (
    <InputEnhancements
      addonRight={addonRight}
      addonLeft={addonLeft}
      label={label}
      withErrorMessage={withErrorMessage}
      containerClassName={containerClassName}
      field={field}
      fieldState={fieldState}
    >
      <OriginalColorPicker
        disabled={field.disabled}
        {...props}
        name={field.name}
        onBlur={field.onBlur}
        onChange={(event) => {
          field.onChange(event);
          triggerDependencies();
        }}
        ref={field.ref}
        value={field.value}
        id={field.name}
        className={classNames({ 'p-invalid': fieldState.error }, className)}
        format="hex"
      />
    </InputEnhancements>
  ),
);

type OmittedProps = 'id' | 'ref' | 'value' | 'onBlur' | 'onChange' | 'format';

type PropTypes = Omit<ColorPickerProps, OmittedProps> & FormInputEnhancements;

export default ColorPicker;
